import Http from './../http';

const prefix = '/external_file';

const encodeDataToURL = data => {
  return Object.keys(data)
    .map(value => `${value}=${encodeURIComponent(data[value])}`)
    .join('&');
};


export const get = id => {
    return Http.authApi().get(`${prefix}/${id}`);
};

export const create = file => {
  return Http.authApi().post(`${prefix}`, file);
};

export const edit = file => {
  return Http.authApi().put(`${prefix}/${file.id}`, file);
};

export const exclude = ids_files => {
  return Http.authApi().delete(`${prefix}/${ids_files[0]}`);
};

export const excludeMultiple = ids_files => {
  let stringIds = (Object.keys(ids_files).map(key =>`id_file[]=${ids_files[key]}`).join('&'));
  return Http.authApi().delete(`${prefix}/${ids_files[0]}/multiple?${stringIds}`);
};

export const moveFiles = data => {
  return Http.authApi().post(`${prefix}/move-file/change`, data);
};

export const removeDirectoryFile = data => {
  return Http.authApi().post(`${prefix}/move-file/remove-directory`, data);
};



// WEBPACK FOOTER //
// ./src/js/services/files/file.js